export default __webpack_public_path__ + "static/media/photo--sm--69.2f4ad723.jpg";